mutation (
  $input: String!
) {
  sendPhoneForm(
    input: $input
  )
}
